import * as t from 'io-ts';
import { either } from 'fp-ts/lib/Either';
import { DateTime as DateTimeStoreModel } from 'acscp/store';

export const DateTime = new t.Type<DateTimeStoreModel, DateTimeStoreModel, unknown>(
    'DateTime',
    (unknownObject): unknownObject is DateTimeStoreModel => unknownObject instanceof DateTimeStoreModel,
    (unknownObject, context) => either.chain(
        t.string.validate(unknownObject, context),
        s => {
            const parsedDate = new DateTimeStoreModel(s);
            return parsedDate.isValid()
                ? t.success(parsedDate)
                : t.failure(unknownObject, context);
        }),
    dateTime => dateTime
);
